import type { Transition } from "framer-motion";
import { useContext } from "react";

import type { SpringPreset } from "./presets";
import { AnimationContext, type AnimationContextValue } from "./provider";

export function useAnimation(): AnimationContextValue {
  const context = useContext(AnimationContext);
  if (!context) {
    throw new Error("useAnimation must be used within an AnimationProvider");
  }
  return context;
}

export function useAnimationSpring(preset: SpringPreset): Transition {
  const { getSpring } = useAnimation();
  return getSpring(preset);
}

export function useAnimationExitSpring(preset: SpringPreset): Transition {
  const { getExitSpring } = useAnimation();
  return getExitSpring(preset);
}
